import React from "react";
import { Button, Tooltip, Dropdown, Menu, Input, Select } from "antd";
import {
  CaretRightOutlined,
  HolderOutlined,
  PlusOutlined,
  DeleteOutlined,
  SwapOutlined,
} from "@ant-design/icons";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

function SortableSubdivisionPanel({
  id,
  subdivisionName,
  children,
  headerContent,
  isExpanded,
  onToggle,
  panelStyle,
  onAddSubmittal,
  onDeleteSubdivision,
  onMoveSubdivision,
  divisions,
  currentDivision,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: id,
    data: { type: "subdivision", subdivisionName },
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    marginBottom: "12px", // Margin from original code's "mb-3" class equivalent
    opacity: isDragging ? 0.5 : 1,
    cursor: "default",
    ...panelStyle, // Apply the #FAFAFA background and borders
  };

  console.log(currentDivision, "!!");

  return (
    <div ref={setNodeRef} style={style} {...attributes} className="mb-3">
      {/* Header Area */}
      <div
        onClick={onToggle}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "12px 16px",
          //   cursor: "default",
          borderBottom: isExpanded
            ? `1px solid ${panelStyle.borderColor || "#d9d9d9"}`
            : "none",
        }}
      >
        {/* Drag Handle */}
        {/* <div
          {...listeners}
          style={{
            cursor: "grab",
            marginRight: "12px",
            color: "#bfbfbf",
            display: "flex",
            alignItems: "center",
          }}
        >
          <HolderOutlined />
        </div> */}

        {/* Expand Arrow */}
        <div
          //   onClick={onToggle}
          style={{
            cursor: "pointer",
            marginRight: "12px",
            display: "flex",
            alignItems: "center",
            padding: "5px",
          }}
        >
          <CaretRightOutlined rotate={isExpanded ? 90 : 0} />
        </div>

        {/* Content */}
        <div style={{ flex: 1 }}>{headerContent}</div>
        <div className=" d-flex gap-2">
          <Button
            // type="primary"
            onClick={(e) => {
              e.stopPropagation();
              onAddSubmittal(subdivisionName);
            }}
          >
            <PlusOutlined /> Add Submittal
          </Button>
          <Select
            placeholder="Move to division"
            showSearch
            optionFilterProp="children"
            style={{ width: 150 }}
            popupMatchSelectWidth={false}
            onSelect={(value) =>
              onMoveSubdivision(currentDivision, value, subdivisionName)
            }
            value={undefined}
            onClick={(e) => e.stopPropagation()} //  prevent panel toggle
          >
            {Object.entries(divisions)
              .filter(([key]) => {
                const codeOnly = currentDivision.split(" ")[0];
                return !key.startsWith(codeOnly);
              })
              .sort((a, b) => parseInt(a[0], 10) - parseInt(b[0], 10))
              .map(([key, name]) => (
                <Select.Option key={key} value={key}>
                  {`${key} - ${name}`}
                </Select.Option>
              ))}
          </Select>
          <Button
            type="link"
            // danger
            shape="circle"
            onClick={(e) => {
              e.stopPropagation();
              onDeleteSubdivision(subdivisionName);
            }}
          >
            <Tooltip title="Delete Subdivision">
              <DeleteOutlined className=" link-danger" />
            </Tooltip>
          </Button>
        </div>
      </div>

      {/* Body Area */}
      {isExpanded && (
        <div
          style={{
            background: "#fff",
            borderRadius: "0 0 8px 8px",
            overflow: "hidden",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}

export default SortableSubdivisionPanel;
